import { makeAutoObservable } from 'mobx'

export class DowngradeContentStore {
  private _selectedReason: string | null = null
  private _reasonDesc = ''

  constructor() {
    makeAutoObservable(this)
  }

  get selectedReason() {
    return this._selectedReason
  }

  setSelectedReason = (reason: string) => {
    this._selectedReason = reason
  }

  clearSelectedReason = () => {
    this._selectedReason = null
  }

  get reasonDesc() {
    return this._reasonDesc
  }

  setReasonDesc = (value: string) => {
    this._reasonDesc = value
  }

  clearReasonDesc = () => {
    this._reasonDesc = ''
  }
}
